import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import isMobile from 'is-mobile';

export const Route = createFileRoute('/')({
  /* mint-disable-next-line no-component-in-sync-route */
  component: Outlet,

  async beforeLoad({ context, location }) {
    const isAuthenticated = await context.isAuthenticated();

    if (!isAuthenticated && location.pathname === '/') {
      throw redirect({
        to: '/login/',
      });
    } else if (isAuthenticated && location.pathname === '/') {
      if (isMobile()) {
        throw redirect({
          to: '/ai-hub',
        });
      }
      if (
        (await context.hasPermission('campaignPlanningFeature:view')) ||
        (await context.hasPermission('campaignSettingsFeature:view')) ||
        (await context.hasPermission('campaignStrategyFeature:view')) ||
        (await context.hasPermission('campaignTraffickingFeature:view'))
      ) {
        throw redirect({
          to: '/campaigns',
        });
      }

      // If the user has no campaign-related permissions, redirect to the company profile page
      // All roles have access to the company profile page, so this is a safe default.
      throw redirect({
        to: '/company-profile',
      });
    }
  },
});
